import _ from "lodash";
import React from "react";
import {
  GetAllActiveItemDimession,
  GetActiveitemCategory,
} from "../../../axios";
import { Button, FormCheckBox, FormDropDown } from "../../../components";
import LoaderComponent from "../../../components/common/Loader";
import { colors } from "../../../configs";
import Strings from "../../../translations";

const CreateCategoryDimenssionMappingForm = (props) => {
  const {
    errorMessage,
    setMessage,
    handleResultData,
    actionType,
    initialValue = {},
    handleModalClose,
  } = props;

  const [loading, setLoading] = React.useState(false);
  const [initialItemDimenssion, setInitialItemDimenssion] = React.useState([]);
  const [itemDimenssion, setItemDimenssion] = React.useState([]);
  const [selectData, setSelectData] = React.useState({
    value: "",
    error: false,
    success: true,
  });
  const [options, setOptions] = React.useState([]);
  const [searchTerm, setSearchTerm] = React.useState("");

  React.useEffect(() => {
    setInitialItemDimenssion(
      initialValue.dimenssions?.map((d) => ({
        key: d.id,
        name: d.name,
        checked: true,
      })) || []
    );

    setSelectData({
      value: initialValue.id || "",
      error: false,
      success: actionType === "edit" ? true : false,
    });

    setLoading(true);
    const dimensionIds = initialValue.dimenssions?.map((d) => d.name) || [];

    GetAllActiveItemDimession()
      .then((res) => {
        setItemDimenssion(
          res.data.data.map((elm) => ({
            key: elm.id,
            name: elm.name,
            checked: dimensionIds.includes(elm.name),
          }))
        );
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [initialValue, actionType]);

  const getAllActiveItemCategory = () => {
    setLoading(true);
    GetActiveitemCategory()
      .then((res) => {
        setOptions(
          res.data.data.map((elm) => ({
            key: elm.id,
            value: elm.id,
            label: elm.name,
          }))
        );
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  React.useEffect(() => getAllActiveItemCategory(), []);

  const handleChangeCheck = (key) => {
    const result = itemDimenssion.map((item) =>
      item.key === key ? { ...item, checked: !item.checked } : item
    );
    setItemDimenssion(result);
  };

  const handleSelectDropDown = (value) => {
    setMessage(null);
    setSelectData(value);
  };

  const getSelectedDimensionIds = () =>
    itemDimenssion.filter((i) => i.checked).map((i) => i.key);

  const handleSaveData = () => {
    const formData = {
      item_category_id: selectData.value,
      item_dimension_ids: getSelectedDimensionIds(),
    };
    handleResultData(formData);
  };

  const disableAdd =
    selectData.value === "" ||
    selectData.error ||
    selectData.success === false ||
    itemDimenssion.every((item) => !item.checked);

  const disableEdit =
    _.isEqual(
      itemDimenssion.map((i) => ({ key: i.key, checked: i.checked })),
      initialItemDimenssion.map((i) => ({ key: i.key, checked: i.checked }))
    ) && selectData.value === (initialValue.id || "");

  const pageHeader = Strings["ItemCategoryDimenssion.CreateMapping"],
    editpageHeader = Strings["ItemCategoryDimenssion.EditMapping"],
    dropdownLabel = Strings["ItemCategoryPropertyMapping.SelectItemCategory"],
    dropdownCustomError =
      Strings["VendorCompanytoCategoryMapping.CategoryCustomError"],
    selectText = Strings["ItemCategoryDimenssion.SelectPlaceHolder"],
    selctRoleHeader = Strings["ItemCategoryDimenssion.SelectItemDimenssion"],
    SaveButton = Strings["VendorCompanytoCategoryMapping.SaveBtn"],
    cancelButton = Strings["VendorCompanytoCategoryMapping.CancelBtn"];

  const filteredItemDimenssion = React.useMemo(() => {
    if (!itemDimenssion || !Array.isArray(itemDimenssion)) return [];
    return itemDimenssion.filter((item) =>
      item?.name?.toLowerCase().includes(searchTerm?.toLowerCase() || "")
    );
  }, [itemDimenssion, searchTerm]);

  return (
    <div className="modalFormContainer">
      {loading && <LoaderComponent />}
      <h2>{actionType === "add" ? pageHeader : editpageHeader}</h2>
      {errorMessage && <h6 style={{ color: "red" }}>{errorMessage}</h6>}

      <FormDropDown
        labelStyle={{ marginTop: "10px", marginBottom: "10px" }}
        selectText={selectText}
        Label={dropdownLabel}
        Options={options}
        onSelect={handleSelectDropDown}
        customErrorLine={dropdownCustomError}
        searchable={false}
        value={selectData.value}
        disable={actionType === "edit"}
        isValidate={true}
      />

      <br />
      <h4>{selctRoleHeader}</h4>
      <div style={{ marginBottom: "15px" }}>
        <input
          type="text"
          placeholder="Search item dimensions..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: "8px",
            width: "100%",
            border: "1px solid #ddd",
            borderRadius: "10px",
            fontSize: "14px",
            marginBottom: "20px",
            outline: "none",
          }}
        />
      </div>

      <div className="row">
        {filteredItemDimenssion.map((dim) => (
          <div className="col-12 col-md-4" key={dim.key}>
            <FormCheckBox
              Label={dim.name}
              checked={dim.checked}
              handleChangeCheck={() => handleChangeCheck(dim.key)}
            />
          </div>
        ))}
      </div>

      <div className="row deleteFunction__buttongroup">
        <div style={{ display: "flex", marginTop: "30px" }}>
          <Button
            buttonName={SaveButton}
            disable={actionType === "add" ? disableAdd : disableEdit}
            onClick={handleSaveData}
            buttonStyle={{ backgroundColor: colors.primary }}
          />
          <Button
            buttonName={cancelButton}
            onClick={() => {
              handleModalClose();
              setMessage(null);
            }}
            buttonStyle={{
              backgroundColor: colors.darkgrey,
              marginLeft: "10px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateCategoryDimenssionMappingForm;
